import { List, Stack, Typography } from '@mui/material';
import { useEntitySearch } from 'api/entity';
import React, { useMemo } from 'react';

import { SearchResultEntityListItems } from '../components/entityList';
import { SearchQuery } from '../processQuery';

export function SearchChildrenSearch(props: {
  value: SearchQuery;
  setQuery: (query: string) => void;
  onClick: (open: boolean) => void;
}) {
  const { value, setQuery } = props;

  const { data } = useEntitySearch(value.queryText);

  const { queryText } = value;

  const filteredEntities = useMemo(
    () =>
      data?.filter((x) => {
        if (x.name.toLowerCase().includes(queryText.toLowerCase())) {
          return true;
        }

        if (x.description?.toLowerCase().includes(queryText.toLowerCase())) {
          return true;
        }

        return false;
      }) ?? [],
    [data, queryText],
  );

  if (!queryText.length) {
    return (
      <Stack alignItems="center" justifyContent="center" height="40vh">
        <Typography variant="h6">
          Please enter a search term to search among child entities.
        </Typography>
      </Stack>
    );
  }

  return (
    <List disablePadding>
      <SearchResultEntityListItems
        overrideClick
        entities={filteredEntities ?? []}
        onClick={(_, e) => {
          setQuery(`@<${e?.id}>`);
        }}
      />
    </List>
  );
}
